<template>
	<div class="container">
		<div class="content">
			<div class="breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item replace :to="{ path: '/my/index' }">个人中心</el-breadcrumb-item>
					<el-breadcrumb-item replace :to="{ path: '/my/insureList' }">我的保单</el-breadcrumb-item>
					<el-breadcrumb-item>保单详情</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="box">
				<div class="box-title">
					基本信息
				</div>

				<div class="basic-info">
					<div class="basic-item">
						<div class="basic-item-title">
							产品名称
						</div>
						<div class="basic-item-value">
							{{ data.goods_name }} - {{ data.goods_specs_name }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							保单号
						</div>
						<div class="basic-item-value">
							{{ data.policy_no || '暂未生成' }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							承保公司
						</div>
						<div class="basic-item-value">
							由{{ data.insurer_name }}承保
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							保单状态
						</div>
						<div class="basic-item-value">
							{{ data.statusText }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							支付状态
						</div>
						<div class="basic-item-value">
							{{ payStatusText }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							起保时间
						</div>
						<div class="basic-item-value">
							{{ data.pln_start_date }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							终保时间
						</div>
						<div class="basic-item-value">
							{{ data.pln_end_date }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							保险周期
						</div>
						<div class="basic-item-value">
							{{ data.insured_days }}天
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							保费
						</div>
						<div class="basic-item-value">
							￥{{ data.amount }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							下单时间
						</div>
						<div class="basic-item-value">
							{{ data.created_at }}
						</div>
					</div>
				</div>

				<div class="box-title">
					备注信息
				</div>

				<div class="remark">
					{{ data.remark }}
				</div>
			</div>
	
			<!-- 支付区域：见费出单模式下，未支付且有 pay_url 时显示 -->
			<div class="box pay-section-box" v-if="data.pay_status === 0 && data.pay_url">
				<div class="box-title">
					支付信息
				</div>
				<el-alert title="保单待支付" type="warning" :closable="false"
					description="保单已投保成功，请完成支付后保单将正式生效。">
				</el-alert>
				<el-button type="primary" @click="goToPay" style="margin-top: 12px;">
					去支付
				</el-button>
			</div>
	
			<div class="box">
				<div class="box-title">
					保单服务
				</div>
				<div class="box-btn">
					<div class="box-btn-item" @click="$navto('/my/createClaim?orderId=' + data.id)">
						<el-image :src="require('@/../static/my/insure/sqlp.png')" />
						<div>申请理赔</div>
					</div>
					<div class="box-btn-item" @click="handleInvoiceClick">
						<el-image :src="require('@/../static/my/insure/kjfp.png')" />
						<div>{{ invoiceBtnText }}</div>
					</div>
					<!-- 电子保单：投保成功且已支付时显示 -->
					<div class="box-btn-item" v-if="data.insure_status === 2 && data.pay_status === 1"
						@click="downloadPolicy">
						<el-image :src="require('@/../static/my/insure/dzbd.png')" />
						<div>电子保单</div>
					</div>
				</div>
				<!-- 退保按钮：status===3（生效中）且 insure_status===2（投保成功）时显示 -->
				<div class="cancel-section" v-if="data.status === 3 && data.insure_status === 2">
					<el-button type="danger" size="small" @click="showCancelDialog = true">
						申请退保
					</el-button>
				</div>
			</div>

			<div class="box">
				<div class="box-title">
					投保人信息
				</div>

				<div class="basic-info" v-if="data.applicant_info">
					<div class="basic-item">
						<div class="basic-item-title">
							类型
						</div>
						<div class="basic-item-value">
							{{ data.applicant_info.applicant_type_text }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							名称
						</div>
						<div class="basic-item-value">
							{{ data.applicant_info.applicant_name }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							证件类型
						</div>
						<div class="basic-item-value">
							{{ data.applicant_info.applicant_id_type_text }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							证件号码
						</div>
						<div class="basic-item-value">
							{{ data.applicant_info.applicant_id_number }}
						</div>
					</div>
					<div class="basic-item" v-if="data.applicant_info.applicant_type == 1">
						<div class="basic-item-title">
							联系人
						</div>
						<div class="basic-item-value">
							{{ data.applicant_info.applicant_contact_name }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							联系电话
						</div>
						<div class="basic-item-value">
							{{ data.applicant_info.applicant_phone }}
						</div>
					</div>
				</div>
			</div>

			<div class="box">
				<div class="box-title">
					被保人信息
				</div>

				<div class="table">
					<div class="table-item table-header">
						<div class="table-title">
							姓名
						</div>
						<div class="table-title">
							证件类型
						</div>
						<div class="table-title">
							证件号码
						</div>
						<div class="table-title">
							手机号码
						</div>
					</div>
					<div class="table-item" v-for="(item, index) in displayedInsured" :key="index">
						<div class="table-title">
							{{ item.isrd_name }}
						</div>
						<div class="table-title">
							{{ item.isrd_cret_type_text }}
						</div>
						<div class="table-title">
							{{ item.isrd_cret_code }}
						</div>
						<div class="table-title">
							{{ item.isrd_telnumber }}
						</div>
					</div>
				</div>

				<div class="more" @click="insuredMore = !insuredMore" v-if="data.insured && data.insured.length > 10">
					{{ insuredMore ? '收起' : '查看更多' }}
				</div>
			</div>

			<div class="box">
				<div class="box-title">
					保障项目
				</div>

				<div class="item" v-for="(item, index) in data.coverage_plan" :key="index">
					<div class="item-title">
						{{ item.name }}
					</div>
					<div class="item-value">
						{{ item.amount }}
					</div>
				</div>

				<!-- <div class="more">查看更多</div> -->
			</div>
		</div>

		<el-dialog title="申请开票" :visible.sync="invoiceVisible" width="40%">
			<div class="invoice-dialog-tip">电子发票将在开具完成后于发票记录中提供下载</div>
			<el-form :model="invoiceForm" :rules="invoiceRules" ref="invoiceForm" label-width="120px" class="form">
				<el-form-item label="发票类型">
					<div class="invoice-type-readonly">{{ invoiceTypeText }}</div>
					<div class="form-tip">
						*发票类型为投保时的选择，不可修改
					</div>
				</el-form-item>
				<el-form-item label="纳税人类型" prop="tax_player_type">
					<el-radio-group v-model="invoiceForm.tax_player_type">
						<el-radio :label="1">企业</el-radio>
						<el-radio :label="2">个人</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="发票抬头" prop="customer_name">
					<el-input v-model="invoiceForm.customer_name" placeholder="请输入发票抬头" maxlength="255"></el-input>
				</el-form-item>
				
				<!-- 企业纳税人需要填写税号 -->
				<template v-if="invoiceForm.tax_player_type === 1">
					<el-form-item label="纳税人识别号" prop="tax_player_reg_num">
						<el-input v-model="invoiceForm.tax_player_reg_num" placeholder="请输入纳税人识别号" maxlength="255"></el-input>
					</el-form-item>
				</template>

				<el-form-item label="接收邮箱" prop="email_address">
					<el-input v-model="invoiceForm.email_address" placeholder="请输入接收邮箱" maxlength="255"></el-input>
				</el-form-item>

				<el-form-item label="备注" prop="tax_bz">
					<el-input type="textarea" v-model="invoiceForm.tax_bz" placeholder="请输入备注信息" maxlength="255" :rows="3"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button class="invoice-btn save" @click="submitInvoice" :loading="invoiceLoading">
						确认开票
					</el-button>
					<el-button class="invoice-btn" @click="cancelInvoice">
						取消
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<mainFooter />
		<!-- 退保确认对话框 -->
		<el-dialog title="申请退保" :visible.sync="showCancelDialog" width="400px" :close-on-click-modal="false">
			<el-alert title="退保须知" type="warning" :closable="false"
				description="退保后保单将失效，且不可恢复。请确认后再操作。" style="margin-bottom: 16px;">
			</el-alert>
			<el-form label-width="80px">
				<el-form-item label="退保原因">
					<el-input type="textarea" v-model="cancelReason" placeholder="请输入退保原因" :rows="4"
						maxlength="200" show-word-limit></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer">
				<el-button @click="showCancelDialog = false">取消</el-button>
				<el-button type="danger" @click="submitCancel" :loading="cancelLoading">确认退保</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';
	export default {
		components: {
			mainFooter,
		},
		data() {
			return {
				data: {},
				insuredMore: false,
				invoiceVisible: false,
				invoiceLoading: false,
				// 电子保单下载防连点
				downloading: false,
				// 电子发票下载防连点
				invoiceDownloading: false,
				// 退保相关
				showCancelDialog: false,
				cancelReason: '',
				cancelLoading: false,
				invoiceForm: {
					type: 1, // 固定 1-电子普票（开票一律电子发票）
					tax_player_type: 2, // 1-企业,2-个人
					customer_name: '',
					tax_player_reg_num: '',
					email_address: '',
					tax_bz: ''
				},
				invoiceRules: {
					tax_player_type: [
						{ required: true, message: '请选择纳税人类型', trigger: 'change' }
					],
					customer_name: [
						{ required: true, message: '请输入发票抬头', trigger: 'blur' }
					],
					email_address: [
						{ required: true, message: '请输入接收邮箱', trigger: 'blur' },
						{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
					],
					tax_player_reg_num: [
						{
							required: true,
							message: '请输入纳税人识别号',
							trigger: 'blur',
							validator: (rule, value, callback) => {
								if (this.invoiceForm.tax_player_type === 1 && !value) {
									callback(new Error('请输入纳税人识别号'));
								} else {
									callback();
								}
							}
						}
					]
				}
			}
		},
		computed: {
			// 添加计算属性来控制显示的被保人数据
			displayedInsured() {
				if (!this.data.insured) return [];
				if (this.insuredMore) {
					return this.data.insured; // 显示全部
				} else {
					return this.data.insured.slice(0, 10); // 只显示前10条
				}
			},
			// 判断是否可以开票
			canInvoice() {
				if (!this.data.status && this.data.status !== 0) return true;
				// 不能开票的条件：status == 0 || status == 4 || invoice_status > 0
				const cannotInvoice =
					this.data.status === 0 ||
					this.data.status === 4 ||
					(this.data.invoice_status && this.data.invoice_status > 0);
				return !cannotInvoice;
			},
			// 支付状态文字描述：0=待支付, 1=已支付, 2=支付失败
			payStatusText() {
				const map = { 0: '待支付', 1: '已支付', 2: '支付失败' };
				return map[this.data.pay_status] || '-';
			},
			// 发票类型只读展示：按投保时订单选择的 invoice_type（'01'=增值税专票, '02'=增值税普通发票），默认普票
			invoiceTypeText() {
				return this.data.invoice_type === '01' ? '专票' : '普票';
			},
			// 开票按钮文案：0未开票-申请开票 / 1待开票-开票处理中 / 2已开票-下载发票
			invoiceBtnText() {
				if (this.data.invoice_status === 2) return '下载发票';
				if (this.data.invoice_status === 1) return '开票处理中';
				return '申请开票';
			}
		},
		watch: {
			invoiceVisible(val) {
				if (!val) {
					this.resetInvoiceForm();
				}
			},
			'invoiceForm.tax_player_type'(val) {
				// 切换纳税人类型时重置税号
				if (val === 2) {
					this.invoiceForm.tax_player_reg_num = '';
				}
			}
		},
		mounted() {
			this.getData(this.$route.query.id);
		},
		methods: {
			getData(id) {
				if (!id) return;
				this.$load();
				this.$get('app-order/' + id).then(res => {
					this.data = res.data;
				}).catch(err => {
					this.$message.error(err);
				})
			},
			// 去支付：打开太保支付页面
			goToPay() {
				if (this.data.pay_url) {
					window.open(this.data.pay_url, '_blank');
				}
			},

			// 已支付且投保成功 - 下载电子保单
			downloadPolicy() {
				if (this.downloading) return;
				this.downloading = true;
				this.$post('app-cpic-policy-download', {
					order_id: this.data.id
				}).then(res => {
					if (res.data && res.data.policy_file_url) {
						window.open(res.data.policy_file_url, '_blank');
					} else {
						this.$message.error('获取电子保单失败');
					}
				}).catch(err => {
					this.$message.error(err);
				}).finally(() => {
					this.downloading = false;
				});
			},
			
			// 点击开具发票按钮：已开票直接下载、处理中提示、未开票弹表单
			handleInvoiceClick() {
				// 已开票且发票开具成功 → 直接下载已保存的电子发票，不再弹开票表单
				if (this.data.invoice_status === 2 && this.data.invoice && this.data.invoice.cpic_status === 2) {
					this.downloadInvoice();
					return;
				}

				// 开票处理中 → 提示，不弹表单
				if (this.data.invoice_status === 1) {
					this.$message.warning('发票开具处理中，请稍后在发票记录中查看');
					return;
				}

				if (!this.canInvoice) {
					let message = '';
					if (this.data.status === 0) {
						message = '订单状态为待支付，无法开具发票';
					} else if (this.data.status === 4) {
						message = '订单已结束，无法开具发票';
					} else if (this.data.invoice_status === 2) {
						message = this.data.invoice && this.data.invoice.cpic_error
							? '发票开具异常，请稍后在发票记录中查看'
							: '发票已开具，无法重复申请';
					} else {
						message = '当前订单状态无法开具发票';
					}
					this.$message.warning(message);
					return;
				}
				
				// 检查保单号是否存在
				if (!this.data.policy_no) {
					this.$message.warning('保单号暂未生成，无法开具发票');
					return;
				}
				
				this.invoiceVisible = true;
			},

			// 已开票订单 - 直接下载电子发票（接口内部有缓存：本地已保存直接返回，未保存实时调太保并本地化）
			downloadInvoice() {
				if (this.invoiceDownloading) return;
				this.invoiceDownloading = true;
				this.$post('app-cpic-invoice-download', {
					invoice_id: this.data.invoice.id
				}).then(res => {
					if (res.data && res.data.pdf_url) {
						window.open(res.data.pdf_url, '_blank');
					} else {
						this.$message.error('获取电子发票失败');
					}
				}).catch(err => {
					this.$message.error(err.message || err || '获取电子发票失败');
				}).finally(() => {
					this.invoiceDownloading = false;
				});
			},
			
			// 提交开票申请
			submitInvoice() {
				this.$refs.invoiceForm.validate((valid) => {
					if (valid) {
						// 再次验证订单状态
						if (!this.canInvoice) {
							this.$message.warning('订单状态已变更，无法开具发票');
							return false;
						}
						
						this.invoiceLoading = true;
						
						// 构造提交数据（type 固定 1-电子普票，开票一律电子发票）
						const submitData = {
							...this.invoiceForm,
							type: 1,
							order_id: this.data.id,
						};
						
						this.$post('app-order-invoice', submitData).then(res => {
							this.$message.success('开票申请提交成功');
							this.invoiceVisible = false;
							this.resetInvoiceForm();
							// 重新加载订单数据更新发票状态
							this.getData(this.data.id);
						}).catch(err => {
							this.$message.error(err.message || '开票申请提交失败');
						}).finally(() => {
							this.invoiceLoading = false;
						});
					} else {
						this.$message.warning('请完善表单信息');
						return false;
					}
				});
			},
			
			// 取消开票
			cancelInvoice() {
				this.invoiceVisible = false;
				this.resetInvoiceForm();
			},
			
			// 重置开票表单
			resetInvoiceForm() {
				this.$refs.invoiceForm && this.$refs.invoiceForm.resetFields();
				this.invoiceForm = {
					type: 1, // 固定 1-电子普票（开票一律电子发票）
					tax_player_type: 2,
					customer_name: '',
					tax_player_reg_num: '',
					email_address: '',
					tax_bz: ''
				};
				this.invoiceLoading = false;
			},

			// 提交退保申请
			submitCancel() {
				if (!this.cancelReason) {
					this.$message.warning('请输入退保原因');
					return;
				}
				this.$confirm('确认提交退保申请吗？退保后保单将失效且不可恢复。', '退保确认', {
					confirmButtonText: '确认退保',
					cancelButtonText: '再想想',
					type: 'warning'
				}).then(() => {
					this.cancelLoading = true;
					this.$post('app-cpic-policy-cancel', {
						order_id: this.data.id,
						reason: this.cancelReason
					}).then(res => {
						this.$message.success('退保申请已提交');
						this.showCancelDialog = false;
						this.cancelReason = '';
						this.getData(this.data.id); // 刷新数据
					}).catch(err => {
						this.$message.error(err.message || err || '退保失败');
					}).finally(() => {
						this.cancelLoading = false;
					});
				}).catch(() => {});
			}
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;

		/* 笔记本屏幕适配 */
		@media (min-width: 1024px) and (max-width: 1440px) {
			padding-bottom: 20px;
		}

		.content {
			min-height: calc(100vh - 300px);
			margin: 20px auto 40px;
			width: 68%;

			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				width: 85%;
				margin: 15px auto 30px;
				min-height: calc(100vh - 250px);
			}

			.box {
				margin-top: 20px;
				padding: 20px;
				border-radius: 10px;
				background-color: #fff;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					margin-top: 18px;
					padding: 18px;
					border-radius: 8px;
				}

				&.pay-section-box {
					.el-alert {
						margin-bottom: 5px;
					}
				}

				.box-title {
					color: #333333;
					font-size: 20px;
					font-weight: bold;
					width: 120px;
					margin-bottom: 20px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 18px;
						margin-bottom: 18px;
						width: 110px;
					}
				}

				.basic-info {
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					padding-bottom: 20px;
					margin-top: -15px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						padding-bottom: 18px;
						margin-top: -12px;
					}

					.basic-item {
						display: flex;
						width: 33.3%;
						margin-top: 15px;
						font-size: 14px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							width: 50%; /* 改为2列布局 */
							margin-top: 12px;
							font-size: 13px;
						}

						.basic-item-title {
							width: 80px;
							color: #666666;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								width: 70px;
							}
						}

						.basic-item-value {
							color: #333333;
							flex: 1;
						}
					}
				}

				.remark {
					font-size: 14px;
					color: #333333;
					border-top: 1px solid #EEEEEE;
					padding-top: 20px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 13px;
						padding-top: 18px;
					}
				}

				.box-btn {
					display: flex;
					justify-content: space-between;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						justify-content: space-around;
					}

					.box-btn-item {
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						margin: 0 auto;
						cursor: pointer;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							margin: 0 10px;
						}

						.el-image {
							width: 32px;
							height: 32px;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								width: 28px;
								height: 28px;
							}
						}

						div {
								text-align: center;
								color: #333333;
								margin-top: 10px;
								font-size: 16px;
	
								/* 笔记本屏幕适配 */
								@media (min-width: 1024px) and (max-width: 1440px) {
									font-size: 14px;
									margin-top: 8px;
								}
							}
						}
					}
	
					.cancel-section {
						margin-top: 20px;
						padding-top: 20px;
						border-top: 1px solid #EEEEEE;
						text-align: right;
	
						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							margin-top: 18px;
							padding-top: 18px;
						}
					}

				.table {
					width: 100%;

					.table-item {
						width: 100%;
						display: flex;
						padding: 15px 20px;
						border-bottom: 1px solid #EEEEEE;
						font-size: 14px;
						color: #666666;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							padding: 12px 15px;
							font-size: 13px;
						}

						.table-title {
							width: 25%;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								width: 25%;
								word-break: break-all;
							}
						}
					}

					.table-item:last-child {
						border: none;
					}

					.table-header {
						background-color: #F7F7F7;
						color: #333333;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							font-weight: bold;
						}
					}
				}

				.item {
					display: flex;
					justify-content: space-between;
					font-size: 14px;
					margin-bottom: 15px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 13px;
						margin-bottom: 12px;
					}

					.item-title {
						color: #666666;
					}

					.item-value {
						color: #333333;
					}
				}

				.more {
					padding-top: 20px;
					border-top: 1px solid #EEEEEE;
					font-size: 14px;
					color: #999999;
					text-align: center;
					cursor: pointer;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						padding-top: 18px;
						font-size: 13px;
					}
				}
			}
		}
		
		.invoice-dialog-tip {
			font-size: 12px;
			color: #999999;
			margin-bottom: 10px;
		}
		
		.invoice-type-readonly {
			font-size: 14px;
			color: #333333;
			line-height: 40px;
		}
		
		.form {
			margin-top: -20px;
			
			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				margin-top: -15px;
			}
			
			.invoice-btn {
				width: 130px;
				border-radius: 50px;
				line-height: 30px;
				font-size: 14px;
				color: #999999;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					width: 120px;
					line-height: 28px;
					font-size: 13px;
				}
			}
			
			.save {
				background-color: #2280FD;
				color: #fff;
			}
			
			.el-form-item {
				margin-bottom: 20px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					margin-bottom: 18px;
				}
			}
			
			.el-input, .el-textarea {
				width: 100%;
			}
			
			.form-tip {
				font-size: 12px;
				color: #ff4d4f;
				margin-top: 5px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 11px;
					margin-top: 4px;
				}
			}
			
			// 禁用状态的样式
			.el-radio.is-disabled {
				color: #c0c4cc;
				cursor: not-allowed;
			}

			/* 笔记本屏幕适配 - 表单标签 */
			::v-deep .el-form-item__label {
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 13px;
				}
			}

			/* 笔记本屏幕适配 - 表单内容 */
			::v-deep .el-input__inner,
			::v-deep .el-textarea__inner {
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 13px;
				}
			}
		}

		/* 笔记本屏幕适配 - 弹窗 */
		::v-deep .el-dialog {
			@media (min-width: 1024px) and (max-width: 1440px) {
				width: 50% !important;
			}
		}

		/* 笔记本屏幕适配 - 弹窗标题 */
		::v-deep .el-dialog__title {
			@media (min-width: 1024px) and (max-width: 1440px) {
				font-size: 16px;
			}
		}
	}
</style>